import React, { Component } from 'react';
import {
  Text,
  View,
  TouchableHighlight,
} from 'react-native-web';
import ReactPlayer from 'react-player';
import constants from '../global-constants.jsx';
import styles from '../styles/styles.jsx';
import FreqFinder from '../frequency-finder.jsx';
import myVideo from '../assets/AlPachino.mp4'

export default class VideoPlayer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mute: false,
      paused: false,
      result: "none"
    }
    this.old_note = "none";

    this._mountVideo = component => {
      this._video = component;
    };

    this.time = 0;
    this.seekable = 0;
    this.goto_beginning = false;
  }
  componentDidMount() {
    this.initializeFreqFinder();
  }

  componentWillUnmount() {
    console.log("unmounting");
    constants.freqfinder.stop();
  }
  

  initializeFreqFinder() {
    constants.freqfinder = new FreqFinder();
    constants.freqfinder.action = (note) => {
      let newState = this.state;

      if (this.old_note === "special" && note === "none") {
        if (this.goto_beginning) {
          this._video.seekTo(0);
          this.goto_beginning = false;
        }
        newState.paused = !newState.paused;
      }
      if (this.old_note === "left" && note === "none") {
        this.seek(-1.0);
      }
      if (this.old_note === "right" && note === "none") {
        this.seek(+1.0);
      }

      this.old_note = note;


      newState.result = note;
      this.setState(newState);
    }
    constants.freqfinder.start(500);
  }
  seek(time) {
    let newPosition = this.time;
    newPosition -= time;
    newPosition = newPosition > 0 ? newPosition : 0;
    newPosition = newPosition > this.seekable ? this.seekable - 0.1 : newPosition;
    this._video.seekTo(newPosition);
  }


  render() {
    return (
      <View
        style={styles.container}>
          
        <Text>{this.state.result}</Text>
        <ReactPlayer
          ref={this._mountVideo}
          url={myVideo}
          playing={this.state.paused}

          onClick={() => {
            if (this.goto_beginning) {
              this._video.seekTo(0);
              this.goto_beginning = false;
            }
            let newState = this.state;
            console.log(newState);
            newState.paused = !newState.paused;
            this.setState(newState);
          }
          }

          onProgress={
            () => {
              this.time = this._video.getCurrentTime();
              console.log(this.time);
              this.seekable = this._video.getDuration();
            }
          }
          onEnded={() => {
            let newState = this.state;
            newState.paused = true;
            this.goto_beginning = true;
            this.setState(newState);
          }}
          muted={this.state.mute}
          style={{flex:1, width: 'auto', position: 'relative', margin: 'auto'}}
        />

        <View
          style={styles.container}>
          <View style={styles.controlBar}>
            <TouchableHighlight
              style={{ flex: 1, alignItems: 'center', flexDirection: 'column' }}
              onPress={() => {
                this.seek(-1.0);
              }
              }
            >
              <View
                style={{ flex: 1, alignItems: 'center', flexDirection: 'row' }}>
                <svg style={{ transform: 'rotate(180deg)' }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g><path d="M14 12l-14 9v-18l14 9zm-4-9v4l8.022 5-8.022 5v4l14-9-14-9z" /></g></svg>
              </View>
            </TouchableHighlight>
            <TouchableHighlight
              style={{ flex: 1, alignItems: 'center', flexDirection: 'column' }}
              onPress={() => {
                this.seek(1.0);
              }
              }
            >

              <View
                style={{ flex: 1, alignItems: 'center', flexDirection: 'row' }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M14 12l-14 9v-18l14 9zm-4-9v4l8.022 5-8.022 5v4l14-9-14-9z" /></svg>
              </View>
            </TouchableHighlight>
          </View>
        </View>

      </View>
    );
  }
}



